export const UI_KEY = 'BOOKING_PAGE_INITIALIZING';
